import StringTokenizer from './StringTokenizer'
import * as RoxxOperatorsMap from '../lib/RoxxOperators'
const operatorsList = Object.keys(RoxxOperatorsMap)

const RoxxEscapedQuote = '\\"'
const RoxxEscapedQuotePlaceholder = '\\RO_Q'

const RoxxStringDelimiter = '"'
const RoxxArrayStartDelimiter = '['
const RoxxArrayEndDelimiter = ']'
const RoxxDictStartDelimiter = '{'
const RoxxDictEndDelimiter = '}'
const RoxxTokenDelimiters = '{}[]():, \t\r\n"'

/**
 * Type identifier for ope*rator* tokens
 */
export const RoxxTokenTypeRator = 'operator'

/**
 * Type identifier for ope*rand* tokens
 */
export const RoxxTokenTypeRand = 'operand'
/**
 *
 */
export class RoxxTokenizer {
  tokenArray
  arrayAccumulator
  dictionaryAccumulator
  dictKey
  constructor() {
    this.tokenArray = []
    this.arrayAccumulator = undefined
    this.dictionaryAccumulator = undefined
    this.dictKey = undefined
  }

  /**
   * Converts a string token into a Roxx type object.
   * @param {string} token - The token to convert into a Roxx type.
   * @returns {object}
   */
  _stringToRoxx(token) {
    if (operatorsList.includes(token)) return {type: RoxxTokenTypeRator, value: token}
    if (token == 'true') return {type: RoxxTokenTypeRand, value: true}
    if (token == 'false') return {type: RoxxTokenTypeRand, value: false}
    if (token == 'undefined') return {type: RoxxTokenTypeRand, value: undefined}
    if (token.charAt(0) == '"' && token.charAt(token.length - 1) == '"')
      return {type: RoxxTokenTypeRand, value: token.substr(1, token.length - 2)}
    if (!isNaN(token)) return {type: RoxxTokenTypeRand, value: +token}
    // we will never write literal date, it will only come from a custom property (but if we want to, this suppose to work)
    // const tokenAsDate = Date.parse(token)
    // if (!isNaN(tokenAsDate)) return {type: RoxxTokenTypeRand, value: new Date(tokenAsDate)}

    return {type: 'UNKNOWN'}
  }

  /**
   * Pushes a token into either the arrayAccumulator or the tokenArray
   * according to context.
   * @param {*} token - the token to push
   */
  push(token) {
    if (this.dictionaryAccumulator && !this.dictKey) {
      this.dictKey = token.value
    } else if (this.dictionaryAccumulator && this.dictKey) {
      this.dictionaryAccumulator[this.dictKey] = token.value
      this.dictKey = undefined
    } else if (this.arrayAccumulator) {
      this.arrayAccumulator.push(token.value)
    } else {
      this.tokenArray.push(token)
    }
  }

  /**
   * Produces a token array from an expression string. This array is later consumed by RoxxParser
   * @see RoxxParser
   * @param {string} expr - Roxx expression to tokenize
   * @returns {Array}
   */
  tokenize(expr) {
    this.tokenArray = []
    this.arrayAccumulator = undefined
    this.dictionaryAccumulator = undefined

    let delimitersToUse = RoxxTokenDelimiters

    const expression = expr.replace(RoxxEscapedQuote, RoxxEscapedQuotePlaceholder)
    const tokenizer = new StringTokenizer(expression, delimitersToUse, true)

    let token, prevToken
    while (tokenizer.hasMoreTokens()) {
      prevToken = token
      token = tokenizer.nextTokenWithDelimiters(delimitersToUse)

      switch (token) {
        case RoxxDictStartDelimiter:
          this.dictionaryAccumulator = {}
          break
        case RoxxDictEndDelimiter:
          this.tokenArray.push({
            type: RoxxTokenTypeRand,
            value: this.dictionaryAccumulator,
          })
          this.dictionaryAccumulator = undefined
          break
        case RoxxArrayStartDelimiter:
          this.arrayAccumulator = []
          break
        case RoxxArrayEndDelimiter:
          this.tokenArray.push({type: RoxxTokenTypeRand, value: this.arrayAccumulator})
          this.arrayAccumulator = undefined
          break
        case RoxxStringDelimiter:
          if (prevToken == RoxxStringDelimiter) {
            // if previous token was also a string delimiter it means we encounterd an emptry string.
            this.push({type: RoxxTokenTypeRand, value: ''})
          }

          // Swap delimiters to use if needed. we do this so we can have strings with chars that are normally used as delimiters.
          delimitersToUse =
            delimitersToUse == RoxxStringDelimiter
              ? RoxxTokenDelimiters
              : RoxxStringDelimiter
          break
        default:
          if (delimitersToUse == RoxxStringDelimiter) {
            // If get a token that's not RoxxStringDelimiter while using RoxxStringDelimiter as delimiters It's the string value!
            this.push({
              type: RoxxTokenTypeRand,
              value: token.replace(RoxxEscapedQuotePlaceholder, RoxxEscapedQuote),
            })
          } else if (RoxxTokenDelimiters.indexOf(token) == -1) {
            // Is this token a delimiter or something else? if it's something else convert it to a roxx type and push.
            this.push(this._stringToRoxx(token))
          }
          break
      }
    }

    return this.tokenArray
  }
}
